export const ROUTING_URLS = [
    "/checkout/4",
    "/checkout/5",
]